import React from 'react';
import Lottie from 'lottie-react';
import happyDogLottie from '../../../../assets/lottie_animations/happy_dog.json';
import './EmptyState.scss';
import GGButton from '../../../CommonComponents/GGButton/GGButton';
import { SessionManager } from '../../../../services/SessionManager/SessionManager';
import { useNavigate } from 'react-router-dom';

interface EmptyStateProps {
  onBecomeSellerClick?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ onBecomeSellerClick }) => {
  const navigate = useNavigate();
  const isSeller = SessionManager.shared.isSeller();
  
  const handleBecomeSeller = () => {
    if (onBecomeSellerClick) {
      onBecomeSellerClick();
    } else {
      if (isSeller) {
        navigate('/freelancer-dashboard');
      } else {
        navigate('/become-a-freelancer');
      }
    }
  };

  return (
    <div className="empty-state-container">
      <div className="empty-state-content">
        <div className="lottie-container">
            <div className="lottie-background"></div>
          <Lottie 
            className="happy-dog-lottie" 
            animationData={happyDogLottie} 
            loop={true} 
          />
        </div>
        
        <div className="empty-state-text">
          <h2 className="empty-state-title">
            It's quiet here... but full of potential!
          </h2>
          <p className="empty-state-description">
            This category is waiting for talented freelancers like you to make their mark. 
            Be the pioneer who brings amazing services to this space!
          </p>
        </div>
        
        <GGButton 
          className="become-seller-btn"
          variant='outlined'
          btnColor='#00265E'
          roundShape={true}
          onClick={handleBecomeSeller}
        >
          {isSeller ? 'Add new Gig under this category' : 'Start Your Freelancing Journey Now'}
        </GGButton>
      </div>
    </div>
  );
};

export default EmptyState;
